import { render, staticRenderFns } from "./BottomTip.vue?vue&type=template&id=0ee978c4&scoped=true"
import script from "./BottomTip.vue?vue&type=script&lang=js"
export * from "./BottomTip.vue?vue&type=script&lang=js"
import style0 from "./BottomTip.vue?vue&type=style&index=0&id=0ee978c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee978c4",
  null
  
)

export default component.exports